export default __webpack_public_path__ + "static/media/diamond-color-3@2x.d8eb62f9.png";